<template>
  <div>
      <div class="row">
        <div class='col-xl-12 col-lg-12'>
            <div class="card card-stats mb-4 mb-xl-0" style="background-color:#6BBAA7">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h6 class="card-title text-uppercase text-muted mb-0 text-green-stronger">SALDO DEVEDOR</h6>
                    <span class="h4 font-weight-bold mb-0 text-white">{{objetoCabecalho != undefined && objetoCabecalho.valor != undefined ? objetoCabecalho.valor : 0 | formatMoney}}</span>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="btn btn-outline-saldo-devedor" @click="$emit('view-dashboard-repasse', true)"><li class="oi oi-action-undo"></li> VOLTAR</button>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span :class="classLabelBadgeCreditoMes"><i :class="iconClassBadgeCreditoMes"></i>{{objetoCabecalho != undefined && objetoCabecalho.percentual_mes_anterior != undefined ? objetoCabecalho.percentual_mes_anterior : 0 | formatPercent}}</span>
                  <span class="text-nowrap text-white">Desde o mês anterior</span>
                </p>
              </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class='col-xl-12 col-lg-12'>
          <br/>
        </div>
      </div>
      <div class="row">
        
      <transition name="view">
        <div class='col-xl-12 col-lg-12'>
          <ul class="nav nav-tabs flex-column flex-sm-row">
            <li class="nav-item">
              <a class="nav-link" :class="tabSelecionado == 'saldoDevedorEntidade' ? 'active' : '' " href="#saldoDevedorEntidade" @click="tab('saldoDevedorEntidade');"><i class="oi oi-spreadsheet mr-2"></i>Saldo Devedor</a>
            </li>
            <li class="nav-item" v-show="showDetalheEntidade">
              <a class="nav-link" :class="tabSelecionado == 'saldoDevedorEntidadeLancamento' ? 'active' : '' " href="#saldoDevedorEntidadeLancamento" @click="tab('saldoDevedorEntidadeLancamento');"><i class="oi oi-spreadsheet mr-2"></i>Entidade - {{ saldoDevedorSelecionado != undefined ? saldoDevedorSelecionado.entidade : ''}}</a>
            </li>
            <li class="nav-item" v-show="showDetalheEntidadeLancamento">
              <a class="nav-link" :class="tabSelecionado == 'saldoDevedorEntidadeLancamentoDetalhe' ? 'active' : '' " href="#saldoDevedorEntidadeLancamentoDetalhe" @click="tab('saldoDevedorEntidadeLancamentoDetalhe');"><i class="oi oi-spreadsheet mr-2"></i>Lançamento - {{ lancamentoSaldoDevedorSelecionado != undefined ? lancamentoSaldoDevedorSelecionado.descricao_lancamento_repasse : ''}}</a>
            </li>
          </ul>
        </div>
      </transition>
      </div>
      <div class="row">
        <div class='col-xl-12 col-lg-12'>
          <br/>
        </div>
      </div>
      <transition name="view">
      <div class="row" v-show="tabSelecionado == 'saldoDevedorEntidade'">
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl'>
            
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Entidade</th>
                      <th scope="col">Valor Devido</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaSaldoDevedor" v-bind:key="objeto.pk_entidade_sasc" 
                        @click="selectedSaldoDevedorEntidade(objeto)" class="click_link">
                      <td>{{objeto.entidade}}</td>
                      <td>{{objeto.valor_devido | formatMoney}}</td>
                    </tr>
                    <tr>
                      <td scope="col" colspan="2">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold " colspan="1">
                        Total Devido
                      </td>
                      <td scope="col" class="font-weight-bold text-center" >
                        {{totalSaldoDevedor | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
      </div>
      </transition>
      <transition name="view">
        <div class='col-xl-12 col-lg-12' v-show="tabSelecionado == 'saldoDevedorEntidadeLancamento'">
          <br/>
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaSaldoDevedorLancamentoEntidade != undefined && listaSaldoDevedorLancamentoEntidade.length > 0">
            
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Lançamentos</th>
                      <th scope="col">Valor Devido</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaSaldoDevedorLancamentoEntidade" v-bind:key="objeto.pk_repasse_calculado_sasc" @click="selectedSaldoDevedorEntidadeLancamento(objeto)" >
                      <td class="text-left">{{objeto.descricao_lancamento_repasse}} </td>
                      <td>{{objeto.valor_devido | formatMoney}}</td>
                    </tr>
                    <tr>
                      <td scope="col" colspan="2">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold">
                        Total
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalDevidoLancamento | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
      </transition>
      
      <transition name="view">
        <div class='col-xl-12 col-lg-12' v-show="tabSelecionado == 'saldoDevedorEntidadeLancamentoDetalhe'">
          <br/>
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaSaldoDevedorLancamentoEntidadeDetalhe != undefined && listaSaldoDevedorLancamentoEntidadeDetalhe.length > 0">
            
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Lançamentos</th>
                      <th scope="col">Início</th>
                      <th scope="col">Valor Inicial</th>
                      <th scope="col">Valor Pago</th>
                      <th scope="col">Valor Devido</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaSaldoDevedorLancamentoEntidadeDetalhe" v-bind:key="objeto.pk_repasse_calculado_sasc">
                      <td class="text-left">{{objeto.descricao_lancamento_repasse}} </td>
                      <td>{{objeto.data_inicio | formatDate}}</td>
                      <td>{{objeto.valor_inicio | formatMoney}}</td>
                      <td>{{objeto.valor_pago | formatMoney}}</td>
                      <td>{{objeto.valor_devido | formatMoney}}</td>
                    </tr>
                    <tr>
                      <td scope="col" colspan="5">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold" colspan="2">
                        Total
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalInicioLancamentoDetalhe | formatMoney}}
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalPagoLancamentoDetalhe | formatMoney}}
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalDevidoLancamentoDetalhe | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
      </transition>



    </div>
</template>

<script>
import http from "./../../../../axios";
import moment from 'moment'
import { mask } from "vue-the-mask";
moment.locale('pt-BR');
export default {
  name: "DemonstrativoRepasseSaldoDevedorDetalhado",
  props: ['objetoCabecalho'],
  directives: { mask },
  created: function() {
    this.init();
  },
  updated: function(){
    if(this.cooperadoAnterior != this.tokens.id){
      this.getSaldoDevedor();
      this.showDetalheEntidade = false;
      this.showDetalheEntidadeLancamento = false;
    }
  },
  methods: {
    init: function() {
      this.getTokens();
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    },
    tab: function(selecionado){
      this.tabSelecionado = selecionado;
    },
    selectConvenioLancamentoRepasse: function(convenio, lancamentoRepasse){
      this.filterList.convenio = convenio;
      this.filterList.lancamento = lancamentoRepasse;
      this.tab("servicosRecebidos")
    },
    selectedSaldoDevedorEntidade: function(objeto){
      this.saldoDevedorSelecionado = objeto;
      if(this.saldoDevedorSelecionado != undefined){
        this.tabSelecionado = "saldoDevedorEntidadeLancamento";
        this.showDetalheEntidade = true;
        this.showDetalheEntidadeLancamento = false;
        this.getLancamentoEntidadeSaldoDevedor();
      }
    },
    selectedSaldoDevedorEntidadeLancamento: function(objeto){
      this.lancamentoSaldoDevedorSelecionado = objeto;
      if(this.lancamentoSaldoDevedorSelecionado != undefined){
        this.tabSelecionado = "saldoDevedorEntidadeLancamentoDetalhe";
        this.showDetalheEntidadeLancamento = true;
        this.getDetalheLancamentoEntidadeSaldoDevedor();
      }
    },
   getSaldoDevedor: function() {
      this.$Progress.start();
      this.totalSaldoDevedor = 0;
      http
        .get(`api/saldodevedor/cooperado/${this.tokens.id}/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.totalSaldoDevedor = 0;
            this.listaSaldoDevedor = r.data.result;
            this.cooperadoAnterior = this.tokens.id;

            if(this.listaSaldoDevedor != undefined && this.listaSaldoDevedor.length > 0){
              for(var i=0; i < this.listaSaldoDevedor.length; i++){
                this.totalSaldoDevedor = this.totalSaldoDevedor + this.listaSaldoDevedor[i].valor_devido;
              }
            }else{
              this.totalSaldoDevedor = 0;
            }
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getLancamentoEntidadeSaldoDevedor: function() {
      this.totalDevidoLancamento = 0;
      this.$Progress.start();
      http
        .get(`api/saldodevedor/cooperado/${this.tokens.id}/entidade/${this.saldoDevedorSelecionado.pk_entidade_sasc}/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {

            this.listaSaldoDevedorLancamentoEntidade = r.data.result;
            this.entidadeAnterior = this.saldoDevedorSelecionado.pk_entidade_sasc;

            if(this.listaSaldoDevedorLancamentoEntidade != undefined && this.listaSaldoDevedorLancamentoEntidade.length > 0){
              for(var i=0; i < this.listaSaldoDevedorLancamentoEntidade.length; i++){
                this.totalDevidoLancamento = this.totalDevidoLancamento + this.listaSaldoDevedorLancamentoEntidade[i].valor_devido;
              }

            }else{
              this.totalDevidoLancamento = 0;
            }


          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getDetalheLancamentoEntidadeSaldoDevedor: function() {
      this.totalDevidoLancamentoDetalhe = 0;
      this.totalInicioLancamentoDetalhe = 0;
      this.totalPagoLancamentoDetalhe = 0;
      this.$Progress.start();

      http
        .get(`api/saldodevedor/cooperado/${this.tokens.id}/entidade/${this.lancamentoSaldoDevedorSelecionado.pk_entidade_sasc}/lancamento/${this.lancamentoSaldoDevedorSelecionado.pk_lancamento_repasse_sasc}/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaSaldoDevedorLancamentoEntidadeDetalhe = r.data.result;
            this.entidadeLancamentoAnterior = `${this.lancamentoSaldoDevedorSelecionado.pk_entidade_sasc} - ${this.lancamentoSaldoDevedorSelecionado.pk_lancamento_repasse_sasc}`;

            if(this.listaSaldoDevedorLancamentoEntidadeDetalhe != undefined && this.listaSaldoDevedorLancamentoEntidadeDetalhe.length > 0){
              for(var i=0; i < this.listaSaldoDevedorLancamentoEntidadeDetalhe.length; i++){
                this.totalDevidoLancamentoDetalhe = this.totalDevidoLancamentoDetalhe + this.listaSaldoDevedorLancamentoEntidadeDetalhe[i].valor_devido;
                this.totalInicioLancamentoDetalhe = this.totalInicioLancamentoDetalhe + this.listaSaldoDevedorLancamentoEntidadeDetalhe[i].valor_inicio;
                this.totalPagoLancamentoDetalhe = this.totalPagoLancamentoDetalhe + this.listaSaldoDevedorLancamentoEntidadeDetalhe[i].valor_pago;
              }

            }else{
              this.totalDevidoLancamentoDetalhe = 0;
              this.totalInicioLancamentoDetalhe = 0;
              this.totalPagoLancamentoDetalhe = 0;
            }


          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    }
  },
  data: function() {
    return {    
      listaSaldoDevedorLancamentoEntidade: undefined,
      listaSaldoDevedorLancamentoEntidadeDetalhe: undefined,
      totalDevidoLancamento: 0,
      totalDevidoLancamentoDetalhe: 0,
      totalInicioLancamentoDetalhe: 0,
      totalPagoLancamentoDetalhe: 0,
      entidadeAnterior: "",
      entidadeLancamentoAnterior: "",
      listaSaldoDevedor: undefined,
      totalSaldoDevedor: 0,
      cooperadoAnterior: "",
      saldoDevedorSelecionado: undefined,
      lancamentoSaldoDevedorSelecionado: undefined,
      showDetalheEntidade: false,
      showDetalheEntidadeLancamento: false,
      tabSelecionado: "saldoDevedorEntidade",
      tokens: {},
      chartOptions: {
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },


          xaxis: {
            type: 'datetime',
            categories: ["2018-09-19T00:00:00", "2018-09-19T01:30:00", "2018-09-19T02:30:00",
              "2018-09-19T03:30:00", "2018-09-19T04:30:00", "2018-09-19T05:30:00",
              "2018-09-19T06:30:00"
            ],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },

          }
        },

        series: [{
          name: 'series1',
          data: [31, 40, 28, 51, 42, 109, 100]
        }, {
          name: 'series2',
          data: [11, 32, 45, 32, 34, 52, 41]
        }],

        seriesDonut: [44, 55, 41, 17, 15],
        chartOptionsDonut: {
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
    };
  },
  computed: {
    
    classLabelBadgeCreditoMes: function(){
      return this.objetoCabecalho != undefined &&
             this.objetoCabecalho.percentual_mes_anterior != undefined && 
             this.objetoCabecalho.percentual_mes_anterior < 0 ? 
             'badge badge-mod-danger' : 'badge badge-mod-success';
    },
    iconClassBadgeCreditoMes: function(){
      return this.objetoCabecalho != undefined && 
             this.objetoCabecalho.percentual_mes_anterior != undefined && 
             this.objetoCabecalho.percentual_mes_anterior < 0 ? 
             'oi oi-arrow-bottom' : 'oi oi-arrow-top';
    },
    filteredServicosRecebidosAtendimento:function() {
      const { filterList, listaServicosRecebidosAtendimento} = this

      var lista = this.listaServicosRecebidosAtendimento
        .filter(objeto => String(objeto.ano_atendimento).toLowerCase().indexOf(filterList.ano.toLowerCase()) > -1)
        .filter(objeto => objeto.atendimento.toLowerCase().indexOf(filterList.atendimento.toLowerCase()) > -1)
        .filter(objeto => objeto.hospital.toLowerCase().indexOf(filterList.hospital.toLowerCase()) > -1)
        .filter(objeto => objeto.convenio.toLowerCase().indexOf(filterList.convenio.toLowerCase()) > -1)
        .filter(objeto => objeto.acomodacao.toLowerCase().indexOf(filterList.acomodacao.toLowerCase()) > -1)
        .filter(objeto => objeto.paciente.toLowerCase().indexOf(filterList.paciente.toLowerCase()) > -1)
        .filter(objeto => objeto.codigo_procedimento.toLowerCase().indexOf(filterList.procedimento.toLowerCase()) > -1)
        .filter(objeto => Vue.filter("formatDate")(objeto.data_realizacao).toLowerCase().indexOf(filterList.realizacao.toLowerCase()) > -1)
        .filter(objeto => objeto.descricao_lancamento_repasse.toLowerCase().indexOf(filterList.lancamento.toLowerCase()) > -1)
        .filter(objeto => filterList.valor == 0 || (filterList.valor > 0 && objeto.valor_lancamento == filterList.valor));

        this.totalServicosRecebidoAtendimento = 0;

        for(var i=0; i < lista.length; i++){
            this.totalServicosRecebidoAtendimento = lista[i].credito ? 
                                                              this.totalServicosRecebidoAtendimento + lista[i].valor_lancamento : 
                                                            lista[i].debito ? 
                                                              this.totalServicosRecebidoAtendimento - lista[i].valor_lancamento : 
                                                            this.totalServicosRecebidoAtendimento;
        }

      return lista;
    },

  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/demonstrativo/repasse/DemonstrativoRepasseSaldoDevedorDetalhado.vue